import type { WhatsNewResponse } from '../types/api';
import { fetchWithTimeout } from './http';

const BASE = import.meta.env.VITE_API_BASE_URL ?? '';

/** The notes this person may read, newest first. Empty when the panel is off for them. */
export async function fetchWhatsNew(): Promise<WhatsNewResponse> {
  const res = await fetchWithTimeout(`${BASE}/api/v1/whats-new`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<WhatsNewResponse>;
}
